import { Component, ElementRef, inject, input, Input, OnChanges, Renderer2, SimpleChanges, ViewChild } from "@angular/core";

@Component({
  selector: "sxw-circular-progress-number",
  templateUrl: "./circular-progress-number.component.html",
  styleUrls: ["./circular-progress-number.component.scss"],
  host: {
    "[style.width]": "size()",
    "[style.height]": "size()",
    "[style.--circular-size]": "size()",
  },
})
export class CircularProgressNumberComponent implements OnChanges {
  progressValue = input(0);
  color = input("var(--p-primary-600)");
  text = input("");
  size = input("32px", {
    transform: (value: number) => {
      return value > 32 ? "32px" : `${value}px`;
    },
  });

  @ViewChild("circularProgress", { static: true })
  circularProgress!: ElementRef<HTMLDivElement>;

  private renderer = inject(Renderer2);

  ngOnChanges(changes: SimpleChanges) {
    if (changes["progressValue"]) {
      this.renderer.setStyle(
        this.circularProgress.nativeElement,
        "background",
        `conic-gradient(${this.color()} ${this.progressValue() * 3.6}deg, #ededed 0deg)`
      );
    }
  }
}
